import { spacing } from 'elemental-ui';

export const FIELD_BOX_MARGIN_BOTTOM = spacing.xs;
export const BREADCRUMBS_MARGIN_BOTTOM = spacing.m;
export const FIELD_BOX_CONTENT_TEXT_MARGIN_BOTTOM = spacing.xxs;
export const BUTTONS_BOX_VERTICAL_MARGINS = spacing.l;
export const MAX_WIDTH = { maxWidth: '1000px' };
export const WHITE_SPACE = { whiteSpace: 'pre-line' };
